import React, { useState } from 'react';
import { Modal } from './ui/Modal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const openModal = (modalType: string) => {
    setActiveModal(modalType);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  return <>
      <footer className="bg-gray-900 text-white py-12 px-4" data-id="element-148">
        <div className="max-w-4xl mx-auto text-center" data-id="element-149">
          <h3 className="text-2xl font-bold mb-6 font-serif" data-id="element-150">Mamá Digital</h3>
          <p className="text-gray-400 mb-8 max-w-md mx-auto" data-id="element-151">
            Ayudando a mamás latinas a construir ingresos desde casa, sin
            descuidar lo más importante.
          </p>
          <div className="border-t border-gray-800 pt-8 text-sm text-gray-500" data-id="element-152">
            <p data-id="element-153">
              © {new Date().getFullYear()} Mamá Digital. Todos los derechos
              reservados.
            </p>
            <div className="mt-4 space-x-4" data-id="element-154">
              <button onClick={() => openModal('terms')} className="hover:text-white transition-colors cursor-pointer" data-id="element-155">
                Términos
              </button>
              <button onClick={() => openModal('privacy')} className="hover:text-white transition-colors cursor-pointer" data-id="element-156">
                Privacidad
              </button>
              <button onClick={() => openModal('contact')} className="hover:text-white transition-colors cursor-pointer" data-id="element-157">
                Contacto
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-158">
        <div className="prose prose-sm max-w-none text-gray-600" data-id="element-159">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-160">
            1. Aceptación de Términos
          </h3>
          <p className="mb-4" data-id="element-161">
            Al adquirir "Mamá Digital: Cómo Ganar desde Casa con PDFs y
            WhatsApp", aceptas los siguientes términos y condiciones. Este ebook
            es un producto digital diseñado para uso personal y educativo.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-162">
            2. Licencia de Uso
          </h3>
          <p className="mb-4" data-id="element-163">
            Se te otorga una licencia personal, no transferible y no exclusiva
            para usar este ebook. No puedes revender, redistribuir, compartir o
            reproducir el contenido sin autorización expresa por escrito.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-164">
            3. Propiedad Intelectual
          </h3>
          <p className="mb-4" data-id="element-165">
            Todo el contenido, incluyendo textos, gráficos, diseños y métodos
            presentados en "Mamá Digital", está protegido por derechos de autor
            y es propiedad exclusiva de Mamá Digital.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-166">
            4. Garantía y Devoluciones
          </h3>
          <p className="mb-4" data-id="element-167">
            Ofrecemos una garantía de satisfacción de 30 días. Si no estás
            satisfecha con el contenido, puedes solicitar un reembolso completo
            dentro de los primeros 30 días posteriores a la compra.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-168">
            5. Limitación de Responsabilidad
          </h3>
          <p className="mb-4" data-id="element-169">
            Este ebook proporciona información educativa y estrategias
            generales. Los resultados individuales pueden variar. No
            garantizamos ingresos específicos ni resultados comerciales
            determinados.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-170">
            6. Uso del Contenido
          </h3>
          <p className="mb-4" data-id="element-171">
            Puedes implementar las estrategias y métodos enseñados en tu propio
            negocio. Sin embargo, no puedes enseñar, revender o redistribuir el
            contenido del ebook como si fuera tuyo.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-172">
            7. Modificaciones
          </h3>
          <p className="mb-4" data-id="element-173">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. Las modificaciones entrarán en vigor inmediatamente después
            de su publicación.
          </p>
        </div>
      </Modal>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-174">
        <div className="prose prose-sm max-w-none text-gray-600" data-id="element-175">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-176">
            1. Información que Recopilamos
          </h3>
          <p className="mb-4" data-id="element-177">
            Al realizar una compra, recopilamos información básica necesaria
            para procesar tu pedido: nombre, correo electrónico y datos de pago
            (procesados de forma segura por nuestro proveedor de pagos).
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-178">
            2. Uso de la Información
          </h3>
          <p className="mb-4" data-id="element-179">Utilizamos tu información exclusivamente para:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-180">
            <li data-id="element-181">Procesar y entregar tu compra del ebook</li>
            <li data-id="element-182">Enviarte el enlace de descarga y confirmación de compra</li>
            <li data-id="element-183">Proporcionar soporte al cliente si lo necesitas</li>
            <li data-id="element-184">
              Enviar actualizaciones importantes sobre el producto (opcional)
            </li>
          </ul>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-185">
            3. Protección de Datos
          </h3>
          <p className="mb-4" data-id="element-186">
            Implementamos medidas de seguridad para proteger tu información
            personal. Utilizamos conexiones seguras (SSL) y servicios de pago
            certificados que cumplen con los estándares PCI DSS.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-187">
            4. No Compartimos tu Información
          </h3>
          <p className="mb-4" data-id="element-188">
            Nunca vendemos, alquilamos ni compartimos tu información personal
            con terceros para fines de marketing. Tu privacidad es nuestra
            prioridad.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-189">5. Cookies</h3>
          <p className="mb-4" data-id="element-190">
            Utilizamos cookies básicas para mejorar tu experiencia de navegación
            y recordar tus preferencias. No utilizamos cookies de seguimiento
            invasivas.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-191">
            6. Tus Derechos
          </h3>
          <p className="mb-4" data-id="element-192">Tienes derecho a:</p>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-193">
            <li data-id="element-194">Acceder a tu información personal</li>
            <li data-id="element-195">Solicitar la corrección de datos incorrectos</li>
            <li data-id="element-196">Solicitar la eliminación de tus datos</li>
            <li data-id="element-197">Cancelar la suscripción a comunicaciones opcionales</li>
          </ul>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-198">
            7. Cambios en la Política
          </h3>
          <p className="mb-4" data-id="element-199">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos por correo electrónico.
          </p>
        </div>
      </Modal>

      {/* Contact Modal */}
      <Modal isOpen={activeModal === 'contact'} onClose={closeModal} title="Contacto" data-id="element-200">
        <div className="prose prose-sm max-w-none text-gray-600" data-id="element-201">
          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-202">
            ¿Necesitas Ayuda?
          </h3>
          <p className="mb-6" data-id="element-203">
            Estamos aquí para apoyarte en tu camino como Mamá Digital. Si tienes
            preguntas sobre el ebook, problemas con la descarga, o necesitas
            orientación, estamos disponibles para ayudarte.
          </p>

          <div className="bg-rose-50 border border-rose-100 rounded-xl p-6 mb-6" data-id="element-204">
            <h4 className="font-bold text-gray-900 mb-3" data-id="element-205">Soporte al Cliente</h4>
            <p className="text-sm mb-4" data-id="element-206">
              Nuestro equipo de soporte responde en un plazo de 24-48 horas
              durante días hábiles.
            </p>
            <div className="space-y-3" data-id="element-207">
              <div className="flex items-start" data-id="element-208">
                <span className="font-semibold text-gray-700 min-w-[100px]" data-id="element-209">
                  Horario:
                </span>
                <span className="text-gray-600" data-id="element-210">
                  Lunes a Viernes, 9am - 6pm EST
                </span>
              </div>
              <div className="flex items-start" data-id="element-211">
                <span className="font-semibold text-gray-700 min-w-[100px]" data-id="element-212">
                  Idiomas:
                </span>
                <span className="text-gray-600" data-id="element-213">Español e Inglés</span>
              </div>
            </div>
          </div>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-214">
            Preguntas Frecuentes
          </h3>
          <p className="mb-4" data-id="element-215">
            Antes de contactarnos, te recomendamos revisar nuestra sección de
            Preguntas Frecuentes en la página principal. Muchas dudas comunes
            están resueltas allí.
          </p>

          <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-216">
            Tiempo de Respuesta
          </h3>
          <p className="mb-4" data-id="element-217">
            Nos esforzamos por responder todas las consultas dentro de 24-48
            horas. Durante fines de semana y días festivos, el tiempo de
            respuesta puede ser un poco más largo.
          </p>

          <div className="bg-amber-50 border border-amber-100 rounded-xl p-6 mt-6" data-id="element-218">
            <p className="text-sm text-gray-700" data-id="element-219">
              <strong data-id="element-220">Nota:</strong> Para proteger tu privacidad y seguridad, no
              publicamos información de contacto directa en esta página. Toda
              comunicación se gestiona a través de nuestro sistema de soporte
              seguro.
            </p>
          </div>
        </div>
      </Modal>
    </>;
}